import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SUBSCRIPTIONS_FEATURE_KEY,
  State,
  subscriptionsAdapter
} from './subscriptions.reducer';

export const getSubscriptionsState = createFeatureSelector<State>(
  SUBSCRIPTIONS_FEATURE_KEY
);

const { selectAll, selectEntities } = subscriptionsAdapter.getSelectors();

export const getSubscriptionsLoading = createSelector(
  getSubscriptionsState,
  (state: State) => state.loading
);

export const getSubscriptionsError = createSelector(
  getSubscriptionsState,
  (state: State) => state.error
);

export const getAllSubscriptions = createSelector(
  getSubscriptionsState,
  selectAll
);

export const getSelectedSubscriptionId = createSelector(
  getSubscriptionsState,
  (state: State) => state.activeSubscriptionId
);

export const getSubscriptionsEntities = createSelector(
  getSubscriptionsState,
  selectEntities
);

export const getActiveSubscription = createSelector(
  getSubscriptionsEntities,
  getSelectedSubscriptionId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
